import MediaSlider from '../MediaSlider'
export default function SidebarImage({ settings, media }) {
    return (
        <MediaSlider type={2} media={media} />
    )
}